import { tupleToStringKey } from 'js/lib/stringKeyTuple';

export const getResourceId = (branchId: string, itemId: string, atomId?: string): string => {
  return atomId || tupleToStringKey([branchId, itemId]);
};
